const BYTE_ORDER_MARK = "﻿";

function isHeaderLine(line: string): boolean {
  const columns = line.split(",").map((column) => column.trim().toLowerCase());
  return (
    columns.includes("url") &&
    columns.includes("login") &&
    columns.includes("password")
  );
}

function startsWithHeader(text: string): boolean {
  const firstContentLine = text
    .split("\n")
    .map((line) => line.trim())
    .find((line) => line.length > 0);

  let startsWithHeaderOutcome: boolean;
  if (firstContentLine === undefined) {
    startsWithHeaderOutcome = false;
  } else {
    startsWithHeaderOutcome = isHeaderLine(firstContentLine);
  }
  return startsWithHeaderOutcome;
}

function stripLeadingHeader(text: string): string {
  const lines = text.split("\n");
  const headerIndex = lines.findIndex((line) => line.trim().length > 0);

  let stripLeadingHeaderOutcome: string;
  if (headerIndex !== -1 && isHeaderLine(lines[headerIndex])) {
    lines.splice(headerIndex, 1);
    stripLeadingHeaderOutcome = lines.join("\n").trim();
  } else {
    stripLeadingHeaderOutcome = text;
  }
  return stripLeadingHeaderOutcome;
}

export function appendCsvContent(existing: string, fileText: string): string {
  let withoutBom: string;
  if (fileText.startsWith(BYTE_ORDER_MARK)) {
    withoutBom = fileText.slice(BYTE_ORDER_MARK.length);
  } else {
    withoutBom = fileText;
  }
  const normalizedFile = withoutBom.trimEnd();

  let csvContent: string;
  if (existing.trim().length === 0) {
    csvContent = normalizedFile;
  } else {
    let appended: string;
    if (startsWithHeader(existing) && startsWithHeader(normalizedFile)) {
      appended = stripLeadingHeader(normalizedFile);
    } else {
      appended = normalizedFile;
    }
    csvContent = `${existing.trimEnd()}\n${appended}`;
  }

  return csvContent;
}
